var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "risk-assessment scroll-form",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "headline indigo darken-4 white--text fixed-header",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.powra.pointOfWorkRiskAssessment').toUpperCase()) + "\n      ")]), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('PowraTitle', {
    attrs: {
      "avatar": 'E',
      "title": _vm.$vuetify.t('$vuetify.powra.controlMeasuresSafetyPrecautions')
    }
  }), _c('v-flex', {
    staticClass: "font-weight-bold",
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.yes')) + "\n          "), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.powra.controlMeasuresPrecautions')))])]), _vm._l(_vm.powraData.controls, function (control, i) {
    return _c('v-flex', {
      key: control.code,
      class: i % 2 == 0 ? '' : 'blue-grey lighten-5',
      attrs: {
        "xs12": "",
        "px-3": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "py-0",
      attrs: {
        "value": control,
        "color": "green"
      },
      on: {
        "change": function change($event) {
          return _vm.updateControls($event);
        }
      },
      model: {
        value: _vm.selectedControls[control.code],
        callback: function callback($$v) {
          _vm.$set(_vm.selectedControls, control.code, $$v);
        },
        expression: "selectedControls[control.code]"
      }
    }, [_c('div', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v("\n              " + _vm._s(control.name) + "\n            ")])])], 1);
  })], 2), _c('powra-f', {
    attrs: {
      "controls": _vm.controls
    },
    on: {
      "newControl": function newControl($event) {
        var _vm2;
        return (_vm2 = _vm).addControl.apply(_vm2, arguments);
      },
      "adequateControlsToHazards": function adequateControlsToHazards($event) {
        var _vm3;
        return (_vm3 = _vm).updatePowraFAdequateControlsToHazards.apply(_vm3, arguments);
      }
    }
  }), _c('div', {
    staticClass: "footer text-xs-center mb-3"
  }, [_c('v-divider'), _c('v-card-text', [_c('v-btn', {
    on: {
      "click": function click($event) {
        return _vm.back();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.back')) + "\n          ")]), _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": function click($event) {
        return _vm.confirm();
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.proceedToTheNextSection')) + "\n          ")]), _c('abort-visit', {
    on: {
      "aborted": function aborted($event) {
        var _vm4;
        return (_vm4 = _vm).visitAborted.apply(_vm4, arguments);
      }
    }
  })], 1)], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.errorDialog,
      callback: function callback($$v) {
        _vm.errorDialog = $$v;
      },
      expression: "errorDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline red white--text",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.powra.checkSafetyPrecautions')) + "\n      ")]), _c('v-card-text', [_c('v-container', {
    attrs: {
      "pa-1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "shrink": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "red",
      "x-large": ""
    }
  }, [_vm._v("warning")])], 1), _c('v-flex', {
    attrs: {
      "pl-3": ""
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$vuetify.t('$vuetify.powra.selectAtLeastOneControlMeasure')) + "\n            ")])], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        _vm.errorDialog = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.ok')) + "\n        ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }